// extracted by mini-css-extract-plugin
export default {"tableContainer":"FrontendDataTable_tableContainer__Mrj2T","tableScroll":"FrontendDataTable_tableScroll__7LbE+","table":"FrontendDataTable_table__gUKqM"};